import React, { ChangeEvent } from 'react';
import {
  ChatPreferenceType,
  Dealer,
} from '@upstart/harmony/lib/legos/dealerTypes';
import './ChatPreference.scss';

interface ChatPreferenceProps {
  dealer?: Dealer;
  updateDealerRequest: Function;
}

export const ChatPreference: React.FC<ChatPreferenceProps> = ({
  dealer,
  updateDealerRequest,
}: ChatPreferenceProps) => {
  const isChatPrefSelected = (value: ChatPreferenceType) => {
    const chatPreference =
      dealer?.wizard?.instore?.chatPreference ?? ChatPreferenceType.all;
    return chatPreference === value;
  };

  const onChatPreferenceChange = (
    changeEvent: ChangeEvent<HTMLInputElement>,
  ) => {
    const newDealer = {
      id: dealer?.id ?? '',
      wizard: {
        instore: {
          chatPreference: changeEvent.target.value as ChatPreferenceType,
        },
      },
    };
    updateDealerRequest({ dealer: newDealer, isDiffObject: true });
  };

  const getRadioButton = (chatPref: ChatPreferenceType, label: string) => (
    <div className="radio-button">
      <input
        type="radio"
        name="chatPreference"
        value={chatPref}
        checked={isChatPrefSelected(chatPref)}
        onChange={onChatPreferenceChange}
        data-testid={`chatPref-${chatPref}`}
      />
      {label}
    </div>
  );

  return (
    <div className="chat-preferences">
      <div>Chat Preferences</div>
      <div className="radio-buttons">
        {getRadioButton(ChatPreferenceType.all, 'Show all')}
        {getRadioButton(ChatPreferenceType.chatOnly, 'Chat only')}
        {getRadioButton(ChatPreferenceType.disabled, 'Disabled')}
      </div>
    </div>
  );
};
